import { DashboardPageContainer, Header, Title } from '../styles'
import { useAtom } from 'jotai'
import ErrorBoundary from '@/components/errorBoundary'
import DashboardTable from '@/features/dashboard/components/dashboardTable/DashboardTable'
import { selectedSensorCardAtom } from '@/core/store/globalStore'
import SensorDetails from '../components/sensorDetails/SensorDetails'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

const Dashboard = () => {
    const [selectedSensorCard] = useAtom(selectedSensorCardAtom)
    const selectedSensorKey =
        selectedSensorCard?.sensor.sensorDbKey ??
        selectedSensorCard?.sensor.tag ??
        selectedSensorCard?.sensor.vendorSerialNumber

    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const renderSensorDetailsMobile = windowWidth <= 1024 && selectedSensorCard && selectedSensorCard.show
    const renderSensorDetailsDesktop = windowWidth > 1024 && selectedSensorCard && selectedSensorCard.show

    return (
        <>
            <DashboardPageContainer $fitViewport={!!renderSensorDetailsMobile}>
                <ErrorBoundary>
                    {renderSensorDetailsMobile ? (
                        <SensorDetails
                            key={selectedSensorKey}
                            sensor={selectedSensorCard.sensor}
                            isMobile={true}
                            editOnboarded={selectedSensorCard.editOnboarded}
                        />
                    ) : (
                        <>
                            <DashboardContentContainer>
                                <ButtonsAndCardsContainer>
                                    <Header>
                                        <Title variant="h1">Sensor overview</Title>
                                    </Header>
                                    <DashboardTable />
                                </ButtonsAndCardsContainer>
                                {renderSensorDetailsDesktop && (
                                    <SensorDetails
                                        key={selectedSensorKey}
                                        sensor={selectedSensorCard.sensor}
                                        isMobile={false}
                                        editOnboarded={selectedSensorCard.editOnboarded}
                                    />
                                )}
                            </DashboardContentContainer>
                        </>
                    )}
                </ErrorBoundary>
            </DashboardPageContainer>
        </>
    )
}

const ButtonsAndCardsContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    overflow-y: hidden;
    padding-top: 24px;
    padding-left: 24px;

    @media (max-width: 1024px) {
        padding: 0 4px;
    }
`

const DashboardContentContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
`
export default Dashboard
